import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/useFocusRing-DPVmdx21.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../3rdPartyModules/_react-aria/utils/dist/mergeProps-CTIwukXV.js';
import styled, { css } from 'styled-components';
import { T as Tooltip } from '../Tooltip/Tooltip-Dluoz4wv.js';
import { f as focusOutline } from '../FocusIndicator/styleMixins/focusOutline-DNwtedBp.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { I as Icon } from '../Icon/Icon-BzSaWXwl.js';
import { i as infoCircle } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-sBnDaVj5-23EprBeB.js';

const StyledTooltip = /*#__PURE__*/styled(Tooltip).withConfig({
  componentId: "sc-storm-ui-30074035__sc-16veikq-0"
})([""]);
StyledTooltip.displayName = 'StyledTooltip';
const TooltipButton = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30074035__sc-16veikq-1"
})(["border:none;background:transparent;padding:", ";margin:", ";outline:none;:focus{", "}"], ({
  theme
}) => theme.helptip.triggerIcon.padding, ({
  theme
}) => theme.helptip.triggerIcon.margin, ({
  focusVisible
}) => focusVisible && focusOutline);
const TooltipIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30074035__sc-16veikq-2"
})(["color:", ";display:block;font-size:", ";:hover{color:", ";cursor:pointer;}", ""], ({
  theme
}) => theme.helptip.triggerIcon.color, ({
  theme
}) => theme.helptip.triggerIcon.size, ({
  theme
}) => theme.helptip.triggerIcon.hoverColor, isMobile(css(["font-size:", ";"], ({
  theme
}) => theme.helptip.triggerIcon.mobile.size)));
TooltipIcon.displayName = 'TooltipIcon';
class HelpTip extends PureComponent {
  render() {
    const {
      id,
      tabIndex,
      children,
      triggerLabel,
      triggerProps,
      renderTrigger,
      taktId,
      taktValue,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('help-tip')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(StyledTooltip, _extends({}, rest, {
      id: id,
      suppressClassNameWarning: true,
      trigger: /*#__PURE__*/React__default.createElement(TooltipButton, _extends({}, getDataTaktAttributes(), triggerProps, {
        tabIndex: tabIndex,
        type: "button",
        "aria-label": triggerLabel
      }), renderTrigger),
      message: children
    })));
  }
}
_defineProperty(HelpTip, "propTypes", {
  /**
   * The id attribute that is supplied to the popover element.
   * Useful for identifying the tooltip in front-end telemetry.
   */
  id: PT.string,
  /**
   * The help tip tab index.
   */
  tabIndex: PT.number,
  /**
   * Add the tooltip contents.
   */
  children: PT.oneOfType([PT.arrayOf(PT.node), PT.node]).isRequired,
  /**
   * Label for the trigger icon.
   */
  triggerLabel: PT.string,
  /**
   * Additional props that are applied to the help tip trigger button.
   */
  triggerProps: PT.objectOf(PT.any),
  /**
   * Render prop to override the trigger icon.
   */
  renderTrigger: PT.node
});
_defineProperty(HelpTip, "defaultProps", {
  id: undefined,
  tabIndex: 0,
  triggerLabel: 'Open tooltip',
  triggerProps: {},
  renderTrigger: /*#__PURE__*/React__default.createElement(TooltipIcon, {
    type: infoCircle,
    blockSize: true
  })
});

export { HelpTip as H, TooltipButton as T, TooltipIcon as a };
//# sourceMappingURL=HelpTip-NOgcj-z5.js.map
